module.exports = __webpack_public_path__ + "static/img/scanning.bd5b6af2.gif";